import { ShoppingCart } from "lucide-react";
import { Header } from "../ui/header";
interface CartHeaderProps {
  itemCount: number;
}
export const CartHeader = ({ itemCount }: CartHeaderProps) => {
  const cartIcon = (
    <div className="relative">
      <ShoppingCart className="w-6 h-6 text-black" />
      {itemCount > 0 && (
        <div className="absolute -top-2 -right-2 w-5 h-5 bg-[#1e4aa8] rounded-full flex items-center justify-center">
          <span className="text-xs font-bold text-white">{itemCount}</span>
        </div>
      )}
    </div>
  );
  return (
    <Header
      title="My Cart"
      showBackButton={true}
      rightElement={cartIcon}
    />
  );
};